import type { RouteRecordRaw } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';

export const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: EnumRoutes.dashboard.root.path,
    children: [
      {
        path: '',
        name: EnumRoutes.dashboard.root.name,
        component: () => import('@/views/dashboard/DashboardLayout.vue'),
        meta: EnumRoutes.dashboard.root.meta,
      },
      {
        path: EnumRoutes.dashboard.userActivities.path,
        name: EnumRoutes.dashboard.userActivities.name,
        component: () => import('@/views/dashboard/UserActivities.vue'),
        meta: EnumRoutes.dashboard.userActivities.meta,
      },
      {
        path: EnumRoutes.dashboard.allAnnouncements.path,
        name: EnumRoutes.dashboard.allAnnouncements.name,
        component: () =>
          import('@/views/dashboard/announcements/AllAnnouncementsPage.vue'),
        meta: EnumRoutes.dashboard.allAnnouncements.meta,
      },
    ],
  },
];
